const Message = ({ gameState, setGameState, wrong, word }) => {
  return gameState === "play" && wrong.length > 0 ? (
    <div className="message">Wrong: {wrong.join(", ")}</div>
  ) : gameState === "same" ? (
    <div className="message">You have already entered this letter</div>
  ) : gameState === "lost" ? (
    <div className="lost">
      <div>Unfortunately you lost.</div>
      <div>Word was: {word}</div>
      <button onClick={() => setGameState("new")}>Play Again</button>
    </div>
  ) : gameState === "won" ? (
    <div className="won">
      <div>Congratulations! You won!</div>
      <button onClick={() => setGameState("new")}>Play Again</button>
    </div>
  ) : (
    ""
  );
};

export default Message;
